<template>
  <div class="chart-block">
    <a
      :class="['settings']"
      href="#"
      data-tip="Chart settings"
      @click.prevent="onEdit"
    >
      <ion-icon name="settings"></ion-icon>
    </a>
    <div class="chart-content">
      <component
        v-if="ready"
        :key="chartKey"
        ref="chart"
        v-bind:is="content.chartType"
        :chart-data="computedChartData"
        :options="content.chartOptions"
      ></component>
      <!--<ChartLegend v-if='isLegendType' :chartdata='computedChartData'></ChartLegend>-->
    </div>
  </div>
</template>
<script>
import BlockDefinitions from '../lib/BlockDefinitions';
import DoughnutChart from '@/components/charts/DoughnutChart.vue';
import BarChart from '@/components/charts/BarChart.vue';
import LineChart from '@/components/charts/LineChart.vue';
import ProgressChart from '@/components/charts/ProgressChart.vue';
import RadarChart from '@components/charts/RadarChart.vue';
import ChartLegend from './ChartLegend.vue';
import Utilities from '@/lib/Utilities';
import TranslationMixin from '@/lib/TranslationMixin';
import Vue from 'vue';
export default {
  props: {
    editable: { type: Boolean, default: false },
    config: { type: Object, default: () => {} },
  },
  components: {
    DoughnutChart,
    BarChart,
    LineChart,
    ProgressChart,
    ChartLegend,
    RadarChart,
  },
  mixins: [TranslationMixin],
  data() {
    return {
      ready: false,
      content: {},
      chartKey: null,
      globalChartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        legend: { display: true },
        tooltips: {
          callbacks: {
            label: this.tooltipFormat,
          },
        },
      },
    };
  },
  created() {
    this.content = this.config;
    this.chartKey = Utilities.key();
    if (
      !this.content.chartData ||
      Object.keys(this.content.chartData).length == 0
    ) {
      this.content.chartData = JSON.parse(
        JSON.stringify(this.defaultChartData)
      );
    } else {
      this.content.chartData = this.processChartData(this.content.chartData);
    }

    if (typeof this.content.chartOptions === 'string') {
      this.content.chartOptions = this.$store.state.calculations[
        this.content.chartOptions
      ](this.$store);
    } else {
      const tooltipSettings = {
        callbacks: {
          label: this.tooltipFormat,
        },
      };
      Vue.set(this.content.chartOptions, 'tooltips', tooltipSettings);
    }
    this.$nextTick(() => (this.ready = true));
  },
  computed: {
    defaultChartData() {
      return BlockDefinitions[this.content.chartType].options.chartData;
    },
    isLegendType() {
      return ['DoughnutChart'].indexOf(this.content.chartType) !== -1;
    },
    computedChartData() {
      return JSON.parse(JSON.stringify(this.content.chartData));
    },
  },
  methods: {
    processChartData(data) {
      // let copy = JSON.stringify(JSON.parse(data))
      if (typeof data.calculated !== 'undefined') {
        Object.assign(
          data,
          this.$store.state.calculations[data.calculated](this.$store, data)
        );
      } else {
        for (let i = 0; i < data.datasets.length; i++) {
          const dataset = data.datasets[i];
          if (typeof dataset.calculated !== 'undefined') {
            Object.assign(
              dataset,
              this.$store.state.calculations[dataset.calculated](this.$store)
            );
          }
        }
      }

      const jsonCopy = JSON.stringify(data);
      return JSON.parse(this.$varReplace(jsonCopy));
    },
    message(mess) {
      console.log(mess);
    },
    onEdit() {
      this.$emit('edit', {
        fields: [],
        editorConfig: {
          title: 'Chart',
          blocks: BlockDefinitions,
          onDelete: this.onDelete,
          onChange: this.onChange,
          chartFields: this.getChartFields,
        },
        editorClass: 'ChartEditPanel',
      });
    },
    getChartFields() {
      return this.$refs.chart.getChartSettings();
    },
    onDelete() {
      this.$emit('delete', this);
    },
    onChange(newData, newType, newOptions) {
      this.content.chartData = JSON.parse(JSON.stringify(newData));
      const options = Object.assign({}, this.globalChartOptions, newOptions);
      this.content.chartOptions = JSON.parse(JSON.stringify(options));
      this.content.chartType = newType;
      this.chartKey = Utilities.key();
      this.$emit('change', this.content);
    },
    tooltipFormat(args) {
      const datasetIndex = args.datasetIndex;
      const i = args.index;
      let label = this.content.chartData.labels[i];
      if (label.length > 30) {
        label = label.substr(0, 30) + '...';
      }
      const dataset = this.content.chartData.datasets[datasetIndex];
      const total = dataset.data.reduce((a, b) => a + b);
      const value = dataset.data[i];
      const percent = ((value / total) * 100).toFixed(2);
      let format;
      let fullLabel, translated;
      switch (this.content.chartType) {
        case 'RadarChart':
          // fullLabel = label.join(' ');
          // translated = this.$t(fullLabel, fullLabel, 'radar');
          format = '';
          break;
        case 'DoughnutChart':
          format = `${label}: ${percent}%`;
          break;
        default:
          format = `${label}: ${value}`;
      }

      return format;
    },
  },
};
</script>
<style lang="scss" scoped>
.chart-block {
  position: relative;

  a.settings {
    position: absolute;
    top: 10px;
    left: 10px;
  }
}
</style>
